import AppConstants from '../constants/app.constants'

// STATE
const dashboardStorage = localStorage.getItem(AppConstants.STORAGE_DASHBOARD_OBJECT)
const dashboardStorageFullscreen = localStorage.getItem(AppConstants.STORAGE_DASHBOARD_FULLSCREEN_OBJECT)
const batchSelectedStorage = localStorage.getItem(AppConstants.BATCH_SELECTED_STORAGE)
const emptyObj = {
  zoomValue: {},
  chuteInfoDisplay: 0,
  chuteLayer: 0
}
const state = {
  _dashboardStorage: JSON.parse(dashboardStorage) || emptyObj,
  _dashboardStorageFullscreen: JSON.parse(dashboardStorageFullscreen) || emptyObj,
  _batchSelectedStorage: batchSelectedStorage || ''
}

// ACTIONS
const actions = {
  async updateBatchSelected({ commit }, value) {
    commit('setBatchSelected', value)
  },
  async updateDashboardStorage({ commit }, value) {
    commit('setDashboardStorage', value)
  },
  async updateChuteZoomValue({ commit }, chuteZoomValue) {
    commit('setChuteZoomValue', chuteZoomValue)
    commit('setDashboardStorage', state['_dashboardStorage'])
  },
  async updateChuteInfoDisplay({ commit }, chuteInfoDisplay) {
    commit('setChuteInfoDisplay', chuteInfoDisplay)
    commit('setDashboardStorage', state['_dashboardStorage'])
  },
  async updateChuteLayer({ commit }, chuteLayer) {
    commit('setChuteLayer', chuteLayer)
    commit('setDashboardStorage', state['_dashboardStorage'])
  },
  async updateChuteZoomValueFullscreen({ commit }, chuteZoomValue) {
    commit('setChuteZoomValueFullscreen', chuteZoomValue)
    commit('setDashboardFullscreenStorage', state['_dashboardStorageFullscreen'])
  },
  async updateChuteInfoDisplayFullscreen({ commit }, chuteInfoDisplay) {
    commit('setChuteInfoDisplayFullscreen', chuteInfoDisplay)
    commit('setDashboardFullscreenStorage', state['_dashboardStorageFullscreen'])
  },
  async updateChuteLayerFullscreen({ commit }, chuteLayer) {
    commit('setChuteLayerFullscreen', chuteLayer)
    commit('setDashboardFullscreenStorage', state['_dashboardStorageFullscreen'])
  }
}
// MUTATIONS
const mutations = {
  setDashboardStorage(state, dashboardStorage) {
    state['_dashboardStorage'] = dashboardStorage
    localStorage.setItem(AppConstants.STORAGE_DASHBOARD_OBJECT, JSON.stringify(dashboardStorage))
  },
  setChuteZoomValue(state, zoomValue) {
    state['_dashboardStorage']['zoomValue'] = zoomValue
  },
  setChuteInfoDisplay(state, chuteInfoDisplay) {
    state['_dashboardStorage']['chuteInfoDisplay'] = chuteInfoDisplay
  },
  setChuteLayer(state, chuteLayer) {
    state['_dashboardStorage']['chuteLayer'] = chuteLayer
  },
  setDashboardFullscreenStorage(state, dashboardFullscreenStorage) {
    state['_dashboardStorageFullscreen'] = dashboardFullscreenStorage
    localStorage.setItem(AppConstants.STORAGE_DASHBOARD_FULLSCREEN_OBJECT, JSON.stringify(dashboardFullscreenStorage))
  },
  setChuteZoomValueFullscreen(state, zoomValue) {
    state['_dashboardStorageFullscreen']['zoomValue'] = zoomValue
  },
  setChuteInfoDisplayFullscreen(state, chuteInfoDisplay) {
    state['_dashboardStorageFullscreen']['chuteInfoDisplay'] = chuteInfoDisplay
  },
  setChuteLayerFullscreen(state, chuteLayer) {
    state['_dashboardStorageFullscreen']['chuteLayer'] = chuteLayer
  },
  setBatchSelected(state, batchSelected) {
    state['_batchSelectedStorage'] = batchSelected
    localStorage.setItem(AppConstants.BATCH_SELECTED_STORAGE, JSON.stringify(batchSelected))
  }
}
// GETTERS
const getters = {
  getChuteZoomValue() {
    return state['_dashboardStorage']['zoomValue']
  },
  getChuteInfoDisplay() {
    return Number.parseInt(state['_dashboardStorage']['chuteInfoDisplay']) || 0
  },
  getChuteLayer() {
    return Number.parseInt(state['_dashboardStorage']['chuteLayer']) || 0
  },
  getChuteZoomValueFullscreen() {
    return state['_dashboardStorageFullscreen']['zoomValue']
  },
  getChuteInfoDisplayFullscreen() {
    return Number.parseInt(state['_dashboardStorageFullscreen']['chuteInfoDisplay']) || 0
  },
  getChuteLayerFullscreen() {
    return Number.parseInt(state['_dashboardStorageFullscreen']['chuteLayer']) || 0
  },
  getBatchSelected() {
    return state['_batchSelectedStorage'].replaceAll('"', '') || ''
  }
}
export const dashboard = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/dashboard.module.js